import axios from "axios";
import configs from "../configs"
const Ajax = axios.create({
    baseURL: configs.baseURL,
    timeout: 60000,
});

Ajax.interceptors.request.use(
    (config) => {
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        return config;
    },
    (error) => {
        console.log(error);
        Promise.reject(error);
    }
);

Ajax.interceptors.response.use(
    (response) => {
        let res = response.data;
        if (res.code === "45003") {
            console.warn("res.code: 45003");
        }else if(res.code === '160079999999'){
            window.location.href='/login'
        }
        return res;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default Ajax;



// WEBPACK FOOTER //
// ./src/utils/ajax.js